var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 229,
    viewBox: "0 0 233 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.925 165.24C145.017 168.39 147.074 173.456 146.388 178.434L144.93 189.673L142.318 209.125L139.706 228.577L124.182 216.628L126.739 197.247L129.351 177.794L131.909 158.412L140.87 165.31L140.925 165.24Z",
    fill: "#1267C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.328 209.134L85.2411 165.194C82.1362 162.805 78.0644 162.255 74.4481 163.742L62.1492 168.771L139.7 228.461L142.328 209.134ZM140.951 165.373L100.941 134.578L99.2321 147.309C98.6826 151.381 100.359 155.48 103.676 158.033L144.886 189.752L146.415 178.568C147.084 173.465 144.973 168.469 140.951 165.373Z",
    fill: "url(#paint0_linear_248_1162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2186 153.791C49.4566 155.744 44.0872 154.982 40.0107 151.957L31.0489 145.059L15.5246 133.11L0.000267251 121.161L18.082 113.728L33.6063 125.677L49.1306 137.626L64.655 149.575L54.2186 153.791Z",
    fill: "#1556A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.606 84.4219C108.275 79.3186 111.588 75.0141 116.35 73.061L126.77 68.7205L144.852 61.2877L162.934 53.8548L160.377 73.2366L142.295 80.6695L124.213 88.1024L106.131 95.5353L107.606 84.4219Z",
    fill: "#1267C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.047 127.053L121.659 107.6L124.27 88.1478L126.828 68.766L116.408 73.1064C111.646 75.0596 108.333 79.364 107.663 84.4674L106.134 95.6513L104.426 108.382C103.876 112.454 105.553 116.554 108.869 119.107L119.047 127.053ZM150.025 150.896L152.637 131.444L155.249 111.991L157.86 92.539L160.418 73.1572L163.029 53.7047L144.893 61.2082L142.336 80.5901L139.724 100.042L137.113 119.495L135.398 132.671C134.887 136.548 136.46 140.343 139.495 142.679L150.025 150.896Z",
    fill: "#0C2780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.314 209.124L85.2264 165.185C82.1216 162.795 78.0498 162.245 74.4334 163.732L62.1346 168.761L139.686 228.452L142.314 209.124ZM140.936 165.364L100.926 134.568L99.2175 147.299C98.668 151.371 100.344 155.47 103.661 158.023L144.871 189.742L146.4 178.558C147.069 173.455 144.959 168.459 140.936 165.364Z",
    fill: "#11AFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.061 127.062L121.672 107.61L124.284 88.1576L126.842 68.7757L116.421 73.1162C111.659 75.0693 108.346 79.3738 107.677 84.4771L106.148 95.661L104.44 108.392C103.89 112.464 105.567 116.564 108.883 119.116L119.061 127.062ZM150.039 150.906L152.651 131.454L155.262 112.001L157.874 92.5488L160.431 73.1669L163.043 53.7145L144.907 61.218L142.35 80.5998L139.738 100.052L137.126 119.505L135.412 132.681C134.901 136.557 136.474 140.353 139.508 142.688L150.039 150.906Z",
    fill: "#11AFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6939 135.35C83.1443 139.422 80.4286 142.95 76.6331 144.524L64.7632 149.434L54.3432 153.774C49.5811 155.727 44.1574 155.036 40.0647 151.886L31.1029 144.988L49.1846 137.555L67.3206 130.052L85.4567 122.548L83.6939 135.35ZM90.6258 83.7142L72.544 91.1471L54.4623 98.58L36.3806 106.013L18.2446 113.516L0.162849 120.949L15.6872 132.898L33.7689 125.465L51.9049 117.962L70.041 110.458L82.3398 105.429C85.9561 103.942 88.4545 100.696 88.966 96.82L90.6258 83.7142Z",
    fill: "#0F6FC3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_248_1162",
    x1: 81.7286,
    y1: 154.291,
    x2: 126.665,
    y2: 186.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59E4E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/gr.4b71f6d2b601210b0b4da37a6e64eb10.svg";
export { ForwardRef as ReactComponent };